<template>
    <div class="opm-optimize-flow" @click="clicked">
        <RouterView />

        <teleport to="body">
            <modals-container></modals-container>
        </teleport>

        <div class="opm-loading-indicator sk-pulse"></div>
    </div>
</template>

<script>
export default {
    mounted() {
        // console.log("MOUNT");
    },
    created() {
        // console.log("CREATE");
    },
    methods: {
        clicked() {
            this.$events.emit('clickedOutside')
        }
    }
}
</script>
